import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  product?: string;
  text: string;
};
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text
}: TestimonialProps) {
  return <article className="glass-panel flex h-full flex-col rounded-2xl p-6 md:p-8" data-id="element-256" data-mp="3azjefymrcmcq">
      <div className="mb-4 flex items-center" data-id="element-257" data-mp="36z97ain8bpwa">
        <div className="mr-3 flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-brand-gold/50 bg-brand-purple text-sm font-bold text-brand-goldLight md:mr-4 md:h-12 md:w-12 md:text-lg" data-id="element-258" data-mp="370agehkoq2bd">
          {initials}
        </div>
        <div data-id="element-259" data-mp="2s28h4jkos2zx">
          <div className="mb-1 flex text-brand-goldBright" data-id="element-260" data-mp="2s2rvjqb4o997">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" data-id="element-261" data-mp="v8wu4c4erodr" />)}
          </div>
          <p className="font-semibold text-brand-text md:text-lg" data-id="element-262" data-mp="qav93lnf9ezn">{name}</p>
          <p className="text-xs text-brand-muted md:text-sm" data-id="element-263" data-mp="h4wui1ce4aho">
            {location}
            {product ? ` — ${product}` : ''}
          </p>
        </div>
      </div>
      <p className="flex-grow font-serif text-sm italic leading-relaxed text-brand-textLight md:text-base" data-id="element-264" data-mp="780jnoz0rc9y">“{text}”</p>
    </article>;
}
export function InitialTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-265" data-mp="zwfwq5ylbkin">
      <div className="mx-auto max-w-3xl" data-id="element-266" data-mp="zxh86bjiq90w">
        <TestimonialCard initials="MV" name="María V." location="Mendoza" product="Terapeuta holística" text="Por primera vez tengo un sistema completo para planificar mis sesiones de Gemoterapia con criterio real. Mis pacientes sienten la diferencia desde la primera sesión y yo dejé de llegar al consultorio sin saber exactamente qué hacer con cada caso." data-id="element-267" data-mp="zyiuxd9wcjyg" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  const testimonials: TestimonialProps[] = [{
    initials: 'MV',
    name: 'María V.',
    location: 'Mendoza',
    product: 'Terapeuta holística',
    text: 'Por primera vez tengo un sistema completo para mis sesiones. El Manual Maestro me cambió la forma de trabajar. Mis pacientes perciben la diferencia y cuando les explico qué cristales usé y por qué, sienten que están en manos de una profesional real.'
  }, {
    initials: 'CL',
    name: 'Carolina L.',
    location: 'Buenos Aires',
    product: 'Terapeuta energética',
    text: 'El Escudo del Terapeuta solo ya vale todo el pack. Antes llegaba a casa agotada después de cada jornada sin entender por qué. Ahora tengo los cinco escudos activos y el ritual de cierre del día y la diferencia es enorme.'
  }, {
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Rosario',
    product: 'Terapeuta en formación',
    text: 'Recién empezaba y el Mega Pack me dio la estructura que necesitaba desde la primera sesión. El tomo de chakras y el diccionario de cristales solos ya valen todo el pack. Llegué al consultorio con criterio desde el día uno.'
  }, {
    initials: 'DL',
    name: 'Daniela L.',
    location: 'Córdoba',
    product: 'Terapeuta holística',
    text: 'La Masterclass de cómo cobrar más me abrió los ojos. Estaba cobrando la mitad de lo que vale mi trabajo. Ahora tengo un precio justo, sé cómo presentarlo y mis pacientes lo perciben como una experiencia premium.'
  }];
  return <Section className="pb-16 pt-8" data-id="element-268" data-mp="2op990is4h9v8">
      <div className="mb-12 text-center" data-id="element-269" data-mp="2oqam0ssp86fl">
        <h2 className="font-display text-2xl font-bold text-brand-purpleDark md:text-4xl" data-id="element-270" data-mp="2on4ul6wlksgp">
          ❤️ LO QUE DICEN LAS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="mx-auto grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-271" data-mp="2xjdxwwnp4b84">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-272" data-mp="20y3se1ecydjv" />)}
      </div>
    </Section>;
}